import { PROMPT_TEMPLATE_TYPES } from "../../constants/promptTemplateTypes";
import { getModelFamily } from "./modelProfiles";

/** @typedef {'kling'|'generic'} TemplateFamily */

/**
 * @typedef {Object} VideoPromptTemplateItem
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} prompt
 */

export function getTemplateFamilyForModel(modelId) {
  if (String(modelId || "").toLowerCase().includes("kling")) return "kling";
  return "generic";
}

/** Maps current model to `prompt_templates.type` for Video Studio. */
export function getVideoPromptDbTypeForModel(modelId) {
  const family = getTemplateFamilyForModel(modelId);
  if (family === "kling") return PROMPT_TEMPLATE_TYPES.VIDEO_KLING;
  return PROMPT_TEMPLATE_TYPES.VIDEO_GENERIC;
}

/** @param {{ id: number, prompt?: string, type?: string }} row */
export function mapDbRowToPickerItem(row) {
  const prompt = (row.prompt || "").trim();
  const firstLine = prompt.split("\n")[0]?.trim() || "";
  const title =
    firstLine.length > 72 ? `${firstLine.slice(0, 69)}…` : firstLine || `Template #${row.id}`;

  return {
    id: String(row.id),
    title,
    description:
      prompt.length > 140 ? `${prompt.replace(/\s+/g, " ").trim().slice(0, 137)}…` : prompt,
    prompt,
  };
}

/** @param {VideoPromptTemplateItem[]} templates */
export function getDefaultPromptFromTemplates(templates) {
  return templates[0]?.prompt || "";
}

export const KLING_MULTI_SHOT_DEFAULTS = [
  {
    prompt:
      "Wide shot: a lone astronaut stands on a rain-soaked neon city rooftop at night, surrounded by blue and magenta light.",
    duration: 3,
  },
  {
    prompt:
      "Close-up: the astronaut helmet visor reflects a giant holographic whale swimming through the sky.",
    duration: 3,
  },
  {
    prompt:
      "Slow push-in: realistic rain particles, emotional sci-fi atmosphere, shallow depth of field, smooth cinematic motion.",
    duration: 3,
  },
];

export function getDefaultMultiPromptForModel(modelId) {
  const family = getModelFamily(modelId);
  if (family === "kling-o3" || family === "kling-3") {
    return KLING_MULTI_SHOT_DEFAULTS.map((s) => ({ ...s }));
  }
  return [{ prompt: "", duration: 3 }];
}
